import React from 'react';
export function GuaranteeSection() {
  return <section className="py-14 md:py-20 bg-negro-medio" data-id="element-186">
      <div className="container" data-id="element-187">
        <div className="bg-negro-suave border border-[rgba(201,151,43,.2)] rounded-lg p-8 md:p-12 grid grid-cols-[auto_1fr] gap-8 md:gap-12 items-center max-md:grid-cols-1 max-md:p-6 max-md:gap-6 max-md:text-center max-sm:p-5" data-id="element-188">
          <div className="max-md:mx-auto" data-id="element-189">
            <img src="https://i.postimg.cc/brqt5whM/selo-garantia-png-2.webp" alt="Garantía" className="w-[155px] max-md:mx-auto max-md:block" data-id="element-190" />
          </div>
          <div data-id="element-191">
            <div className="section-label max-md:justify-center" data-id="element-192">
              Sin riesgo
            </div>
            <h2 className="font-playfair text-[1.85rem] text-blanco mb-3.5" data-id="element-193">
              Garantía de Satisfacción Total de 7 Días
            </h2>
            <p className="text-crema-oscuro leading-[1.8] mb-5 text-[.93rem]" data-id="element-194">
              Explora Código Oscuro con total confianza. Si en los primeros 7
              días decides que no era lo que esperabas, te devolvemos el 100% de
              tu inversión — sin preguntas, sin formularios, sin riesgo.
            </p>
            <p className="text-crema-oscuro leading-[1.8] mb-5 text-[.93rem]" data-id="element-195">
              Creemos en el contenido que entregamos. Por eso no necesitamos
              retenerte con la presión del dinero.
            </p>
            <a href="#oferta" className="btn-primary animate-shimmer" data-id="element-196">
              Acceder con garantía incluida
            </a>
          </div>
        </div>
      </div>
    </section>;
}